import { render } from "./Highlighter.vue?vue&type=template&id=12358fad&scoped=true"
import script from "./Highlighter.vue?vue&type=script&lang=js"
export * from "./Highlighter.vue?vue&type=script&lang=js"

import "./Highlighter.vue?vue&type=style&index=0&id=12358fad&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12358fad"],['__file',"src/pages/scada/components/Highlighter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12358fad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12358fad', __exports__)) {
    console.log('reload')
    api.reload('12358fad', __exports__)
  }
  
  module.hot.accept("./Highlighter.vue?vue&type=template&id=12358fad&scoped=true", () => {
    console.log('re-render')
    api.rerender('12358fad', render)
  })

}


export default __exports__